import React from 'react';

import { Form } from 'antd';

import { THEME } from '@constants/index';
import { openModal } from '@element/index'
import { I18n } from '@utils/index';

import { useVerify } from './useVerify'
import { VerifyMain } from './VerifyForm';

import styles from './airdropVerify.module.less';

interface MainProps {
  resolve: (value: { state: 'cancel' | 'ok', data?: string }) => void;
  close: () => void;
  theme?: Theme;
}

const Main: React.FC<MainProps> = ({ resolve, close, theme = THEME.HIGHLIGHT }) => {
  const {
    userBindInfo: { email, isBindEmail, isBindGoogle, isBindPhone }, onVerify,
    form, onResend, isCountDown, isCountDownemail, setCountDown, setCountDownemail
  } = useVerify({ type: 19 });

  const onFinish = async (value) => {
    const res = await onVerify(value);
    if (!res) return
    close();
    resolve({ state: 'ok', data: res })
  }

  return (
    <Form form={form} onFinish={onFinish} className={styles.form}>
      <VerifyMain
        isBindEmail={isBindEmail}
        isBindPhone={isBindPhone}
        isBindGoogle={isBindGoogle}
        setCountDownemail={setCountDownemail}
        isCountDownemail={isCountDownemail}
        theme={theme}
        businessType="19"
        onResend={onResend}
        setCountDown={setCountDown}
        isCountDown={isCountDown}
        className={styles.loginForm}
        okText={I18n.t('forgetPass_step_one_next')}
        email={email}
      />
    </Form>
  );
}

type IOpenAirdropVerify = (params: { theme?: Theme }) => Promise<{ state: 'cancel' | 'ok', data?: string }>;

/** 二次验证 空投｜修改资金密码用到了 */
export const openAirdropVerify: IOpenAirdropVerify = ({ theme = THEME.HIGHLIGHT }) => {
  return new Promise((resolve) => {
    openModal({
      title: I18n.t('progressbar_twotep'),
      theme,
      children: (close) => (
        <Main resolve={resolve} close={close} theme={theme} />
      ),
      dataBuried: 'close-secondary-verification',
      footer: null
    })
  });
}
